import { render } from "./CallToAction.vue?vue&type=template&id=d1935c22&scoped=true"
import script from "./CallToAction.vue?vue&type=script&lang=js"
export * from "./CallToAction.vue?vue&type=script&lang=js"

import "./CallToAction.vue?vue&type=style&index=0&id=d1935c22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1935c22"]])

export default __exports__